import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";

class MedicalNoteDeletedWarningPopup extends React.Component<any, any> {
    private id: string = "medicalnotedeletedpopumenu";

    public render(): JSX.Element {
        return (
            <Popup
                Id={this.id}
                title={cacheStore.GetString("WarningLabel")}
                closeTarget={LocalPatientOperations.MedicalNote.CloseDeletedEncounterWarningPopup}
                draggable
                manageOverlay
                cssClass="memo"
            >
                <div className="p-body">
                    <div>
                        <span>{cacheStore.GetString("EncounterDeletedLabel")}</span>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button className="btn btn-primary" disabled={false} onClick={() => this.Close()}>{cacheStore.GetString("OKLabel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private Close(): void {
        sessionStore.dispatch(LocalPatientOperations.MedicalNote.CloseDeletedEncounterWarningPopup);
    }
}

export { MedicalNoteDeletedWarningPopup };
